import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ListaComponent } from './lista/lista.component';
import { TramiteAnexoOchoComponent } from "./tramite-anexo-ocho/tramite-anexo-ocho.component";
//import { AuthGuard } from 'app/auth-guard.service';
import { AuthGuard } from '../../auth-guard.service';


const routes: Routes = [
  {
    path:'control-escolar/anexo-ocho',  
    children:[
      {path:'lista', component:ListaComponent},
      {path:'tramite', component:TramiteAnexoOchoComponent},
    ],
    canActivate: [AuthGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AnexoOchoRoutingModule { }
